import { render, staticRenderFns } from "./SimpleImageBlock.vue?vue&type=template&id=409feade"
import script from "./SimpleImageBlock.vue?vue&type=script&lang=js"
export * from "./SimpleImageBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports